import {
  createArrayValidator,
  createObjectValidator,
  validateNumber
} from "../../../../packages/validator/validator.js";
import { QueryItem, validateQueryItem } from "../query/QueryItem.js";

/**
 * Part of VAT report. Includes sales to Estonian clients
 * and reverse charged EU expenses.
 */
export type BaseRateTaxedAmount = {
  /**
   * Total of VAT-taxed transations.
   */
  total: number;
  /**
   * Sales to Estonian clients.
   */
  sales: number;
  /**
   * Items referring to the sale entries.
   */
  salesItems: QueryItem[];
  /**
   * Expenses to non-Estonian EU companies. Must equal "euExpenses".
   */
  reverseCharged: number;
  /**
   * Items referring to the reverse charged entries.
   */
  reverseChargedItems: QueryItem[];
};

export const validateBaseRateTaxedAmount = createObjectValidator<BaseRateTaxedAmount>("BaseRateTaxedAmount", {
  total: validateNumber,
  sales: validateNumber,
  salesItems: createArrayValidator(validateQueryItem),
  reverseCharged: validateNumber,
  reverseChargedItems: createArrayValidator(validateQueryItem)
});
